export default {
  en: {
    'pages.not-found.title': 'Page not found',
    'pages.not-found.copy': 'The page you are looking for has either been moved or does not exist.',
    'pages.not-found.cta': 'Back to homepage',
  },
};
